import React from "react";

const Title = () => {
  return <>Collection</>;
};

export default Title;
